<template>
  <div>
    <div class="tw-flex">
      <label
        v-text="label"
        :for="id"
        :class="{'tw-text-red': hasError}"
        class="tw-mr-2"
      ></label>
      <span v-if="required" class="text-danger">*</span>
    </div>
    <template v-if="hasPrepend">
      <div class="input-group">
        <slot name="prepend"></slot>
        <input
          type="text"
          class="form-control tw-mb-0"
          :class="inputClassMerged"
          :id="id"
          :required="required"
          :name="name"
          :disabled="disabled"
          :placeholder="placeholder"
          :value="value"
          @keyup.enter.prevent="onEnter"
          ref="mainInput"
          v-imask="mask"
          @accept="onAccept"
          @complete="onAccept"
          @input="processEvent"
          :readonly="readOnly"
        />
      </div>
    </template>
    <template v-else>
      <input
        type="text"
        class="form-control tw-mb-0"
        :class="inputClassMerged"
        :id="id"
        :required="required"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        :value="value"
        @keyup.enter.prevent="onEnter"
        ref="mainInput"
        v-imask="mask"
        @accept="onAccept"
        @complete="onComplete"
        @input="processEvent"
        :readonly="readOnly"
      />
      <div class="tw-h-10 tw-flex">
        <small
          class="tw-text-grey tw-font-thin tw-mt-2"
          v-if="description && !hasError"
          v-text="description"
        ></small>
        <small
          v-if="hasError"
          v-text="this.error"
          class="tw-text-red tw-mt-1"
        ></small>
      </div>
    </template>
  </div>
</template>
<script type="text/babel">
  import inputMixin from './input';
  import { IMaskDirective } from 'vue-imask';

  export default {
    name: 'BlastTextInput',

    mixins: [
      inputMixin,
    ],

    directives: {
      imask: IMaskDirective,
    },

    data() {
      return {
        acceptedValue: null,
      };
    },

    props: {
      mask: {
        require: false,
      },
      description: {
        type: String,
        default: null,
      },
    },

    computed: {
      hasPrepend() {
        return !!this.$slots.prepend;
      },

      inputClassMerged() {
        return this.inputClass + (this.hasError
          ? 'tw-border-red tw-border-b-2'
          : '');
      },
    },

    methods: {
      onAccept(event) {
        this.$emit('input', event.detail.unmaskedValue);
      },

      onComplete(event) {
        this.$emit('input', event.detail.value);
      },

      processEvent(event) {
        if (!this.mask) {
          this.$emit('input', event.target.value);
        }
      },
    },
  };
</script>

